import {TrackingStatus} from 'types';
import {CheckIcon, CloseIcon} from 'pages/Tracking/icons';
import {getStatusLabel} from '../../useTracking';
import styles from './DeliveryTimeline.module.scss';

type Props = {
  status: TrackingStatus;
  stopsBeforeCount: number;
  deliveryAddress: string;
  eta: string;
};

const isCompletedStatus = (status: TrackingStatus): boolean =>
  status === 'picked_up' || status === 'delivered';

const isCanceledStatus = (status: TrackingStatus): boolean =>
  status === 'cancel_script';

function DeliveryTimeline({
  status,
  stopsBeforeCount,
  deliveryAddress,
  eta,
}: Props) {
  const statusClass = styles[status.replace('_', '')];

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Delivery Progress</h3>
      <div className={styles.timeline}>
        {stopsBeforeCount > 0 && (
          <div className={styles.timelineItem}>
            <div className={styles.timelineLeft}>
              <div className={`${styles.dot} ${styles.neutral}`}>
                <span>{stopsBeforeCount}</span>
              </div>
              <div className={styles.line} />
            </div>
            <div className={styles.timelineContent}>
              <div className={styles.stopHeader}>
                <span className={styles.stopNumber}>
                  {stopsBeforeCount} {stopsBeforeCount === 1 ? 'stop' : 'stops'}{' '}
                  before yours
                </span>
              </div>
            </div>
          </div>
        )}

        <div className={`${styles.timelineItem} ${styles.current}`}>
          <div className={styles.timelineLeft}>
            <div className={`${styles.dot} ${statusClass}`}>
              {isCompletedStatus(status) && <CheckIcon />}
              {isCanceledStatus(status) && <CloseIcon />}
              {status === 'delivering' && <div className={styles.pulsingDot} />}
            </div>
          </div>

          <div className={styles.timelineContent}>
            <div className={styles.stopHeader}>
              <span className={styles.stopNumber}>Your Delivery</span>
              {eta && <span className={styles.time}>{eta}</span>}
            </div>

            <div className={styles.stopDetails}>
              <span className={styles.address}>{deliveryAddress}</span>
            </div>

            <div className={`${styles.statusTag} ${statusClass}`}>
              {getStatusLabel(status)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeliveryTimeline;
